import { Pressable, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';

import { usePickCoverPhoto } from '@pletly/common';
import { Button } from '../Button';
import { spacing } from '../../theme';
import { UserAvatar } from '../UserAvatar';
import { ProfilePhotoPickerProps } from './types';
import { withTranslation } from '../../locales/hoc';

export const ProfilePhotoPickerComponent = ({
	disabled = false,
	username,
	photoSource,
	onImagePicked,
	...pressableProps
}: ProfilePhotoPickerProps) => {
	const { t } = useTranslation();
	const openPicker = usePickCoverPhoto(onImagePicked);

	const hasPhoto = Boolean(photoSource);

	return (
		<Pressable style={styles.root} onPress={openPicker} disabled={disabled} {...pressableProps}>
			<UserAvatar size={72} username={username} source={photoSource} />

			{!disabled && (
				<Button color="primary" variant={!hasPhoto ? 'filled' : 'outline'} onPress={openPicker}>
					{!hasPhoto
						? t('profile-photo-picker.upload-photo')
						: t('profile-photo-picker.replace-photo')}
				</Button>
			)}
		</Pressable>
	);
};

const styles = StyleSheet.create({
	root: {
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		gap: spacing(2),
	},
});

export const ProfilePhotoPicker = withTranslation(ProfilePhotoPickerComponent);
